// JS
import React, { useState } from 'react';

// COMP
import Button from '../Button';
import MiniBasketPreview from '../MiniBasketPreview';

// COMPONENT
export const AddToBag = ({
  sizeError,
  prodSku,
  setProdSku,
  sizeSelect,
  setSizeSelect,
  setSizeError,
  prodData,
  currency,
  size,
  userSession,
  miniBasketSize,
  miniBasketProdSku,
  miniBasketProdIdData,
  closeQuickViewCleanUp,
  atbButtonTxt = 'Select Size',
  setAtbButtonTxt
}) => {
  // Mini Basket - Preview
  const [showHideMiniBasket, setShowHideMiniBasket] = useState(false);
  const [miniBasketProdId, setMiniBasketProdId] = useState(null);

  const checkSizeSelected = () => {
    !prodSku || !sizeSelect ? setSizeError('error') : setSizeError('');
    setTimeout(() => {
      setSizeError('');
    }, 3000);
  };

  const addToBasketViaElite = (e) => {
    console.log('Adding to basket: ', prodSku);
    setAtbButtonTxt('Adding to bag...');

    if (typeof window.ajaxAddToBasketSimpleAjx === 'function') {
      window.ajaxAddToBasketSimpleAjx(prodSku, 1); // Run Elite Add To Basket
      setAtbButtonTxt('Added');
      setSizeSelect(null);
      setProdSku(null);
      // Mini Basket - Preview
      setShowHideMiniBasket(true);
      setMiniBasketProdId(miniBasketProdIdData);
      setTimeout(function () {
        setAtbButtonTxt('Select Size');
      }, 3500);
    } else {
      setAtbButtonTxt('Add to bag error!');
      setTimeout(function () {
        setAtbButtonTxt('Select Size');
      }, 2500);
    }
  };

  return (
    <>
      {showHideMiniBasket && (
        <MiniBasketPreview
          miniBasketProdId={miniBasketProdId}
          setMiniBasketProdId={setMiniBasketProdId}
          showHideMiniBasket={showHideMiniBasket}
          setShowHideMiniBasket={setShowHideMiniBasket}
          userSession={userSession}
          miniBasketSize={miniBasketSize}
          miniBasketProdSku={miniBasketProdSku}
          closeQuickViewCleanUp={closeQuickViewCleanUp}
          QVMBPopup={true}
        />
      )}
      <Button
        gaAriaLabel="Add to Bag - Quick View"
        gaDataType="seven-pdp-quick-view-basket"
        gaBlockId={prodData.product.productid}
        gaProdSku={prodSku}
        gaList="Product Page"
        gaImage={prodData.product.image}
        gaBrand={prodData.product.attributes.brand}
        gaCategory={prodData.product.attributes.product_category[0]}
        gaTitle={prodData.product.name}
        gaName={prodData.product.name}
        gaPrice={prodData.product.option.priceasnumber}
        gaPromoPrice={prodData.product.option.promotionpriceasnumber}
        gaQuantity={1}
        gaVariant={
          prodData.product.attributes.colour &&
          prodData.product.attributes.colour[0]
        }
        gaCurrency={currency}
        gaSizeSelected={size ? true : false}
        gaSale={prodData.product.option.onsale}
        gaDisabled={!prodData.product.instock}
        buttonSlotNumber={1}
        buttonColour="black"
        buttonLinkContent={
          !prodData.product.instock
            ? 'Out of stock'
            : sizeError
            ? 'Select Size'
            : atbButtonTxt
        }
        setClick={true}
        clickProperties={(e) => {
          checkSizeSelected(false); // Check size is selected
          prodSku && sizeSelect && addToBasketViaElite(e);
        }}
      />
    </>
  );
};
